/* eslint-disable react/prop-types */
import { Box, Typography, Paper, Stack } from "@mui/material";
import { useTheme, alpha } from "@mui/material/styles";
import AccountTreeIcon from "@mui/icons-material/AccountTree";

function MapLegend({ workflowColorMap = {}, workflows = [], t }) {
  const theme = useTheme();

  // Get sorted workflows for consistent display
  const sortedWorkflows = workflows
    .filter((wf) => workflowColorMap[wf.id])
    .sort((a, b) => a.name.localeCompare(b.name));

  if (sortedWorkflows.length === 0) {
    return null;
  }

  return (
    <Paper
      elevation={3}
      sx={{
        position: "absolute",
        bottom: 16,
        left: 16,
        p: 2,
        maxWidth: 300,
        maxHeight: "50vh",
        overflowY: "auto",
        bgcolor: alpha(theme.palette.background.paper, 0.95),
        backdropFilter: "blur(10px)",
        borderRadius: 2,
        border: `1px solid ${theme.palette.divider}`,
        zIndex: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          mb: 1.5,
          pb: 1,
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
      >
        <AccountTreeIcon
          sx={{ fontSize: 20, color: theme.palette.primary.main }}
        />
        <Typography
          variant="subtitle2"
          fontWeight="600"
          color="primary"
          sx={{ textTransform: "uppercase", letterSpacing: "0.5px" }}
        >
          {t("legendTitle") || "Workflow Legend"}
        </Typography>
      </Box>

      <Stack spacing={1}>
        {sortedWorkflows.map((workflow) => (
          <Box
            key={workflow.id}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              p: 0.75,
              borderRadius: 1,
              transition: "background-color 0.2s ease",
              "&:hover": {
                bgcolor: alpha(theme.palette.action.hover, 0.05),
              },
            }}
          >
            <Box
              sx={{
                width: 20,
                height: 20,
                borderRadius: "50%",
                bgcolor: workflowColorMap[workflow.id],
                border: "2px solid #000",
                flexShrink: 0,
                boxShadow: theme.shadows[1],
              }}
            />
            <Typography
              variant="body2"
              sx={{
                fontWeight: 500,
                color: theme.palette.text.primary,
                lineHeight: 1.3,
                wordBreak: "break-word",
              }}
            >
              {workflow.name}
            </Typography>
          </Box>
        ))}
      </Stack>

      {sortedWorkflows.length > 5 && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mt: 1, display: "block", fontStyle: "italic" }}
        >
          {t("legendHint") || "Scroll to see more workflows"}
        </Typography>
      )}
    </Paper>
  );
}

export default MapLegend;

